/** Matches section card horizontal padding (`theme.spacing(3)` = 24px at default density). */
export const signatureFlowContentGutterSx = {
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
    px: 3,
} as const;

/** Space between scrollable signature / upload content and footer actions. */
export const signatureFlowBodyBottomGapSx = {
    paddingBottom: "40px",
} as const;
